import { render, staticRenderFns } from "./RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent.vue?vue&type=template&id=1685f3fe"
import script from "./RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneImpegnativaGruppoPrestazioneListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports